<template>
	<section class="other_page_banner devcode_ban banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							{{
								$t('new_ui.business_development_page.section_banner.title.one')
							}}
						</h5>
						<h2>
							{{
								$t(
									'new_ui.business_development_page.section_banner.main_title.one',
								)
							}}
							<br />{{
								$t(
									'new_ui.business_development_page.section_banner.main_title.two',
								)
							}}
						</h2>
						<h6>
							{{
								$t('new_ui.business_development_page.section_banner.sub_title')
							}}
						</h6>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center"
						>
							<a href="#">{{
								$t(
									'new_ui.business_development_page.section_banner.cta_buttons.one',
								)
							}}</a>
							<a href="#" class="back_off">
								{{
									$t(
										'new_ui.business_development_page.section_banner.cta_buttons.two',
									)
								}}</a
							>
						</div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.business_development_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.business_development_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.business_development_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.business_development_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.business_development_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.business_development_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.business_development_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import devcode from '@/assets/images/sub/dev_code.png';

export default {
	data: () => {
		return {
			img: {
				image1: devcode,
			},
		};
	},
};
</script>
